import logo from "../assets/images/logo.png"
import logo_c from "../assets/images/company_logo.png"
export default {
    home: {
        welcome1: '観察者',
        welcome2: '図書館',
        logo,
        lang: [
            {
                title: '繁體中文',
                key: 'zh-tw'
            },
            {
                title: '简体中文',
                key: 'zh-cn'
            },
            {
                title: 'English',
                key: 'en'
            },
            {
                title: '日本語',
                key: 'ja'
            },
            {
                title: '한국어',
                key: 'ko'
            }

        ],
        reward: "専用報酬",
        welfare: "限定特典",
        up: "イベント内容確認",
        activity: {
            time: {
                title: "イベント期間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 11:00 ",
                month_day_end: "02月03日 11:00",
            },
            content: {
                title: "イベント情報：",
                way: [
                    `1、【限定報酬】をタップすると《Sdorica（スドリカ）》X《ダンジョンズ&ガンボル》コラボ専用報酬を1つ受け取れます。`,
                    `2、【限定特典】をタップしてコラボイベントページに進むとより多くの報酬を受け取れます。`,
                    `3、このページではコラボイベント《Sdorica（スドリカ）》報酬のみを受け取ることができます。`,
                    `4、《ダンジョンズ&ガンボル》報酬を受け取る場合は《ダンジョンズ&ガンボル》イベント関連ページに進んでください。`,
                    `5、報酬は各SID個別の図書館アカウントで1回のみ受け取れます。受取をタップした後、報酬が直接現在ログインしている図書館のアカウントへと送られます。`,
                    `6、報酬はゲーム内メールBOXから受け取れます。メールの有効期限は30日です。受取が完了した後、しっかり受け取れているかどうか確認してください。`
                ]
            }
        }
    },
    welfare: {
        back: "トップへ",
        welcome1: '観察者',
        welcome2: '図書館',
        gumballs_activity: {
            time: {
                title: "イベント期間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 11:00 ",
                month_day_end: "02月03日 11:00",
            },
            content: {
                title: "イベント情報：",
                way: [
                    `1、【《ダンジョンズ&ガンボル》イベントコード受取】をタップするとすぐに《ダンジョンズ&ガンボル》コラボ限定イベントコードを受け取ることができます。`,
                    `2、【《ダンジョンズ&ガンボル》ダウンロード】をタップしてダウンロードし《ダンジョンズ&ガンボル》をインストールしてください。`,
                    `3、《ダンジョンズ&ガンボル》ワールドマップに進む-右上歯車の設定-秘密指令で交換`
                ]
            },
            get_code: "《ダンジョンズ&ガンボル》イベントコード受取",
            download: "《ダンジョンズ&ガンボル》ダウンロード"
        },
        sdorica_activity: {
            time: {
                title: "イベント期間：",
                year_start: "2019年 ",
                year_end: "2020年 ",
                month_day_start: "11月21日 11:00 ",
                month_day_end: "02月03日 11:00",
            },
            content: {
                title: "イベント情報：",
                way: [
                    `1、《ダンジョンズ&ガンボル》コラボイベントページに進み《Sdorica（スドリカ）》コラボ限定イベントコードを受け取ってください。`,
                    `2、以下の入力エリアにコードを入力して受取をタップ。`,
                    `3、各SID個別の図書館アカウントで1回のみ受け取れます。`,
                    `4、図書館名を確認してください。ユーザネームを誤って受取を行い、受取が完了するとそのコードは二度と使用できません。`,
                    `5、報酬はゲーム内メールBOXから受け取れます。メールの有効期限は30日です。受取が完了した後、しっかり受け取れているかどうか確認してください。`
                ]
            },
            label: "イベントコード：",
            placeholder: "タップしてイベントコードを入力",
            noEnter_placeholder: "イベントコードを入力",
            get_welfare: "限定特典受取",
            got_welfare: "限定特典受取済み"
        }
    },
    get_reward: {
        done: {
            title: "受取成功！",
            content: ["報酬がメールBOXに送られました。", "ゲーム内で確認してください"]
        },
        failed: {
            title: "受取失敗！",
            retry:"リトライしてください"
        }
    },
    code_config: {
        title: "《地下城物語 ダンジョンズ&ガンボル(R&D)限定イベントコード",
        copy: "コピー",
        download: "《地下城物語 ダンジョンズ&ガンボル(R&D)》をダウンロードし、対応するイベントページで使用",
        success: 'コピー成功'

    },
    rightCode: '正確なイベントコードを入力してください',
    messageFailed: "受取済みです。重複して受け取ることはできません",
    footer: {
        logo: logo_c,
        company: "© 2019 Rayark Inc. All rights reserved.",
        caseNumber: "",
        copyright: "",
        publicSecurityRecordNumber: "",
        wangwen: ""

    },
    resize: 'スマートフォン/タブレットの向きを真っすぐにしてご覧ください',
    notFound: '申し訳ございません。ページが存在していません',
    network_error: {
        INVALID_REWARD_TYPE: '不正確な報酬',
        EXIST_REWARD_RECORD: '報酬受取済み',
        INVALID_CODE: 'コード認証失敗',
        CODE_USED: '使用済みのコードです',
        GAMEDATA_INVALID_VALUE: '受取失敗',
        OTHER:'受取失敗',
        NO_TOKEN:'このページはゲーム内のイベントプロモーションバナーをクリックして入る必要があります'
    }

}